import React, { useEffect, useState } from 'react'
import { RealEstateDataPageComponentData } from 'types'

const Background_Header_1 = ({ ...props }: RealEstateDataPageComponentData) => {
  const { height, backgroundColor, backgroundHexa } = props

  const [isMounted, setIsMounted] = useState(false)
  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    isMounted && (
      <div
        style={{
          height: screen.width < 1200 ? height?.mobile ?? 'auto' : height?.desktop ?? 'auto',
          backgroundColor: backgroundColor === 'background-picker' ? backgroundHexa : '',
          width: '100%',
        }}
        className={backgroundColor}
      />
    )
  )
}

export default Background_Header_1
